import { SimpleModal } from '@livable/saas-react-components';
import { Alert, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
export const AddCorrectionToCurrentBillingCycle = () => {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    style: {
      marginLeft: '16px'
    },
    'custom-attribute': '594-new-billing-module'
  }, "Add correction");
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    title: "Add correction to current billing cycle",
    trigger: defaultTrigger
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "You are about to apply corrections to the old allocation"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "The correction will be added to your current billing cycle as a custom table and your residents will be extra-charged. Are you sure you wan to add corrections?")), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    'custom-attribute': '595-new-billing-module'
  }, t('Close'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    'custom-attribute': '596-new-billing-module'
  }, t('Add correction'))))))));
};